import { injectModal } from '../modal-provider/ModalProvider';
export default injectModal;
